import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import Modal from "@material-ui/core/Modal";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles"; import ReactPlayer from "react-player";
import { makeStyles } from "@material-ui/core/styles";
// Import Material Icons
import { forwardRef } from "react";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import ViewColumn from "@material-ui/icons/ViewColumn";
import Search from "@material-ui/icons/Search";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import SimpleModal from "./simplemodal";
import LoadingSpinner from "./LoadingSpinner";
import { useParams } from "react-router-dom";
import RefreshIcon from "@mui/icons-material/Refresh";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { DateRangePicker } from "react-date-range";
import { addDays } from "date-fns";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import moment from "moment";
import FileOpenIcon from '@mui/icons-material/FileOpen';// Define the getModalStyle function
import { HelpOutline } from "@mui/icons-material"; // Example icon

function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 40 + rand();
  const left = 45 + rand();
  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    position: "absolute",
    width: 450,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const ViewRecordings = () => {
  const { name } = useParams();

  let fetchURL =
    "https://rms.healtheesystems.com:9443/rms-cctools-0.0.1-SNAPSHOT/api/sms/taxReport/date?startDate=";

  let audioPrefix = "https://rms.healtheesystems.com:9443/rms-cctools-0.0.1-SNAPSHOT/api/v1/download-audio?recordingId="

  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);

    fetchPosts();
  }, []);

  const currentDate = new Date().getFullYear() + '-' +
    (new Date().getMonth() + 1).toString().padStart(2, '0') + '-' +
    new Date().getDate().toString().padStart(2, '0') + "T00:00:00";

  const EndDate = new Date().getFullYear() + '-' +
    (new Date().getMonth() + 1).toString().padStart(2, '0') + '-' +
    new Date().getDate().toString().padStart(2, '0') + "T23:59:59";

  const fetchPosts = async (sdate = currentDate, edate = EndDate) => {
    try {
      setIsLoading(true);

      console.log("Start Date: " + sdate);

      // Ensure date format is YYYY-MM-DD
      let startDate = sdate?.split("T")[0];
      let endDate = edate?.split("T")[0];

      const url = `https://rms.healtheesystems.com:9443/rms-cctools-0.0.1-SNAPSHOT/api/sms/taxReport/date?startDate=${startDate}&endDate=${endDate}`;

      console.log("Fetching data from:", url);

      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const postData = await response.json();
      setPosts(postData);
    } catch (error) {
      console.error("Error fetching posts:", error);
    } finally {
      setIsLoading(false);
    }
  };


  const usePosts = posts.map((post) => { });
  console.log(window.location.href);

  const playRecording = (recFile) => {
    console.log("click method " + recFile);
    setRecordingId(recFile);
    handleOpen();
    setAudioURL(audioPrefix + recFile);
  };
  const classes = useStyles();
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);
  const [recordingId, setRecordingId] = React.useState();
  const [audioUrl, setAudioURL] = React.useState();
  const [viewAs, setViewAs] = React.useState("all");
  const [callType, setCallType] = React.useState("outbound");
  const [mobileNumber, setMobileNumber] = React.useState("");
  const [openSmsDialog, setOpenSmsDialog] = useState(false);
  const [viewDaterangeBoolean, setViewDaterangeBoolean] = React.useState(false);
  const [selectedDateRange, setSelectedDateRange] = React.useState([
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ]);
  const handleOpen = () => {
    setOpen(true);
  };
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm")); // 
  const handleClose = () => {
    setOpen(false);
  };
  const handlecallTypeChange = (event) => {

    if (event.target.value === 'outbound') {
      console.log("Outbound Record");
      setCallType('outbound');
    } else {
      console.log("Inbound Record");
      setCallType('inbound');
    }
    fetchPosts();
  };
  const handleViewChange = (event) => {
    setViewAs(event.target.value);
    if (event.target.value === "all") {
      setViewDaterangeBoolean(false);
      fetchPosts();
    } else setViewDaterangeBoolean(true);
  };
  const handleSelectDateRange = (item) => {
    setSelectedDateRange([item.selection]);
    var newSDate = moment(
      (item.selection.startDate + "").split(" 00:")[0].slice(4),
      "MMM D YYYY"
    ).format("YYYY-MM-DD");
    var newEDate = moment(
      (item.selection.endDate + "").split(" 00:")[0].slice(4),
      "MMM D YYYY"
    ).format("YYYY-MM-DD");
    console.log(newSDate + "=============" + newEDate);
    fetchPosts(newSDate, newEDate);
  };

  function RefreshData() { }

  const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };

  const getCallTypeIcon = (rowData) => {

    console.log("Call Type Get Call Icon: " + rowData.callType);

    switch (rowData.callType) {
      case "Outbound":
        return <PlayCircleIcon />;
      case "Inbound":
        return <PlayCircleIcon />;
      case "SMS":
        return <FileOpenIcon />;
      case "WEBSITE":
        return <FileOpenIcon />;
      default:
        return <PlayCircleIcon />; // Default icon
    }
  };


  const handleSmsClose = () => {
    setOpen(false);
    setOpenSmsDialog(false);
  };

  const openSmsFile = () => {
    setOpen(true)
    setOpenSmsDialog(true);
  }

  const handleCallAction = (rowData) => {
    // if (!rowData?.recordingId) {
    //   console.error("No recording ID found");
    //   return;
    // }

    switch (rowData.callType) {
      case "Outbound":
        handleOutboundCall(rowData.recordingId);
        break;
      case "Inbound":
        handleInboundCall(rowData.recordingId);
        break;
      case "SMS":
        setMobileNumber(rowData.phoneNumber); // Set mobile number from rowData
        handleSmsAction(rowData.phoneNumber);
        break;
      default:
        console.warn("Unknown call type:", rowData.callType);
    }
  };

  // Define different functions based on callType
  const handleOutboundCall = (recordingId) => {
    console.log("Handling outbound call:", recordingId);
    playRecording(recordingId);
  };

  const handleInboundCall = (recordingId) => {
    console.log("Handling inbound call:", recordingId);
    playRecording(recordingId);
  };

  const handleSmsAction = (recordingId) => {
    console.log("Opening SMS file:", recordingId);
    openSmsFile(recordingId); // Custom function for SMS actions
  };

  const columns = [
    { title: "Recording Id", field: "recordingId" },
    { title: "Customer Name", field: "customerName" },
    { title: "Contact Number", field: "phoneNumber" },
    { title: "Office Name", field: "officeName" },
    { title: "Campaign Id", field: "serviceId" },
    { title: "Campaign Name", field: "serviceName" },
    { title: "Agent Login", field: "agentLogin" },
    { title: "Agent Name", field: "agentName" },
    { title: "Call Date", field: "callDate" },
    { title: "Call Type", field: "callType" },
    { title: "Load Id", field: "loadId" },
  ];
  return (
    <div className="App wrapper">
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <br></br>
          <FormControl>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              value={viewAs}
              onChange={handleViewChange}
            >
              <FormControlLabel
                value="all"
                control={<Radio />}
                label="View Today"
              />
              <FormControlLabel
                value="date_range"
                control={<Radio />}
                label="View by Date"
              />
            </RadioGroup>
          </FormControl>{" "}
          <br></br>
          <br></br>
          {viewDaterangeBoolean ? (
            <DateRangePicker
              onChange={handleSelectDateRange}
              moveRangeOnFirstSelection={false}
              editableDateInputs={true}
              ranges={selectedDateRange}
            />
          ) : (
            <></>
          )}
          <MaterialTable
            title="Call Recordings"
            icons={tableIcons}
            columns={columns}
            data={posts} // Ensure this contains full objects
            options={{
              search: true,
              exportButton: { csv: true, pdf: true },
              headerStyle: {
                backgroundColor: "#EEE",
                fontWeight: "bold",
              },
              pageSizeOptions: [5, 10],
            }}
            actions={[
              {
                icon: () => <HelpOutline />, // Placeholder, real icon is set in onClick
                tooltip: "Call Type Action",
                isFreeAction: false,
                onClick: (event, rowData) => {
                  console.log("Clicked Row Data:", rowData); // Check if rowData is correct
                  if (rowData && rowData.callType) {
                    // Manually render correct icon
                    rowData.icon = getCallTypeIcon(rowData);
                    handleCallAction(rowData);
                  } else {
                    console.warn("Row Data missing callType:", rowData);
                  }
                },
              },
              {
                icon: () => <RefreshIcon />,
                tooltip: "Refresh Data",
                isFreeAction: true,
                onClick: () => {
                  setIsLoading(true);
                  fetchPosts().finally(() => setIsLoading(false));
                },
              },
            ]}
          />

        </>
      )}
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={open}
        onClose={handleClose}
      >
        <div style={modalStyle} className={classes.paper}>
          {/* <h2>Simple React Modal</h2>
                    <p>
                        RecordingId is {recordingId}
                    </p> */}
          <ReactPlayer
            url={audioUrl}
            //url="http://azpresencedemo.healtheesystems.com:8090/play/"{{recordingId}}".mp3"
            width="400px"
            height="50px"
            playing={false}
            controls={true}
            config={{
              file: {
                attributes: {
                  controlsList: "nodownload",
                },
              },
            }}
          />
        </div>
      </Modal>

      <Dialog
        open={openSmsDialog}
        onClose={handleSmsClose}
        fullWidth
        maxWidth="md"
        fullScreen={fullScreen} // Enable full screen on small screens
      >
        <DialogTitle>Chat History</DialogTitle>
        <DialogContent dividers>
          <iframe
            src={`https://rms.healtheesystems.com:9443/rms-cctools-ui/chatHistory/${mobileNumber}`}
            width="100%"
            height={fullScreen ? "100vh" : "550px"}
            style={{ border: "none", overflow: "hidden", scrolling: "no" }}
            title="Chat History"
          />

        </DialogContent>
        <DialogActions>
          <Button onClick={handleSmsClose} color="primary" variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default ViewRecordings;
